import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=492ec4a6&scoped=true&"
import script from "./ProjectTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectTasks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTasks.vue?vue&type=style&index=0&id=492ec4a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ec4a6",
  null
  
)

export default component.exports